import { appleImg, bagImg, searchImg } from '../utils';
import { navLists } from '../constants';
import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: "Watch", hasDropdown: true, link: "/watch" },
  { label: "TV", hasDropdown: true, link: "/" },
  { label: "Broadband", hasDropdown: true, link: "/broadband" },
  { label: "Mobile", hasDropdown: true, link: "/mobile" },
  { label: "Deals", hasDropdown: false, link: "/deals" },
];

const SkyLogo = ({ size = 18 }) => (
  <div
  style={{

    borderRadius: "4px",
    padding: `${Math.round(size * 0.22)}px ${Math.round(size * 0.55)}px`,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
  }}
>
  <img
    src="/public/assets/images/logo.PNG" // 👈 replace with your logo path
    alt="Logo"
    style={{
      height: `${size * 1.2}px`, // controls logo size
      width: "auto",
      objectFit: "contain",
    }}
  />
</div>
);


const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
    useEffect(() => {
      const check = () => setIsMobile(window.innerWidth < 768);
      window.addEventListener("resize", check);
      return () => window.removeEventListener("resize", check);
    }, []);

    const m = isMobile;
  return (
    <>
   <nav style={{
        background: "#fff", borderBottom: "1px solid #e0e0e0",
        display: "flex", alignItems: "center",
        padding: m ? "0 16px" : "0 24px",
        height: m ? "52px" : "48px",
        position: "sticky", top: 0, zIndex: 200,
      }}>
        {m ? (
          <>
            <button onClick={() => setMenuOpen(!menuOpen)} style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: "20px", color: "#333", padding: "4px", lineHeight: 1,
            }}>☰</button>
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <SkyLogo size={28} />
            </div>
            <button style={{
              background: "none", border: "1px solid #0072c6", color: "#0072c6",
              borderRadius: "4px", padding: "5px 12px", cursor: "pointer",
              fontSize: "13px", fontWeight: "600",
            }}>Sign in</button>
          </>
        ) : (
          <>
           <a href="/"><SkyLogo size={28} /></a> 
            <div style={{ display: "flex", gap: "4px", flex: 1, marginLeft: "19px" }}>
              {NAV_ITEMS.map((item) => (
                <button key={item.label} style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: "16px", fontWeight: "500", color: "#332",
                  padding: "4px 14px", borderRadius: "4px",
                  display: "flex", alignItems: "center", gap: "8px",
                }}>
                  <a href={item.link}>
                  {item.label}
                  {item.hasDropdown && <span style={{ fontSize: "9px", color: "#666" }}>▾</span>}
                  </a>
                </button>
              ))}
            </div>
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}>🔍</button>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px" }}>🔔</button>
              <button style={{ background: "none", border: "none", cursor: "pointer", fontSize: "13px", color: "#333", display: "flex", alignItems: "center", gap: "4px" }}>
                Help <span style={{ fontSize: "9px" }}>▾</span>
              </button>
              <button style={{
                background: "none", border: "1px solid #0072c6", color: "#0072c6",
                borderRadius: "4px", padding: "5px 14px", cursor: "pointer",
                fontSize: "13px", fontWeight: "600",
              }}>Sign in</button>
            </div>
          </>
        )}
      </nav>
       {m && menuOpen && (
        <div style={{
          position: "fixed", top: "52px", left: 0, right: 0, bottom: 0,
          background: "#fff", zIndex: 190, overflowY: "auto",
          borderTop: "1px solid #e0e0e0",
        }}>
          {NAV_ITEMS.map((item) => (
            <div key={item.label} style={{
              padding: "15px 20px", borderBottom: "1px solid #f0f0f0",
              fontSize: "15px", fontWeight: "500",
              display: "flex", justifyContent: "space-between", cursor: "pointer",
            }}>
              {item.label}
              {item.hasDropdown && <span style={{ color: "#666" }}>›</span>}
            </div>
          ))}
        </div>
      )}
</>

  )
}

export default Navbar